<template>
  <a-modal v-model="visible" :title="$t('shareModal.title')" @ok="handleOk" width="800px" class="share-modal">
    <div class="search">
      <a-input-search 
        class="l-search" 
        allowClear 
        v-model="keyword" 
        :placeholder="$t('shareModal.search.placeholder')" 
        @change="search"
      >
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img
          class="clear"
          v-if="keyword"
          slot="suffix"
          @click=";(keyword = undefined), search()"
          :src="require('@/assets/icons/icon_gb.png')"
        />
        <a-button class="search-btn" slot="enterButton">
          {{ $t('shareModal.search.button') }}
        </a-button>
      </a-input-search>
      <a-radio-group v-if="resId" v-model="isShare" button-style="solid" @change="changeShareStatus">
        <a-radio-button :value="2">
          {{ $t('shareModal.shareStatus.unshared') }}
        </a-radio-button>
        <a-radio-button :value="1">
          {{ $t('shareModal.shareStatus.shared') }}
        </a-radio-button>
      </a-radio-group>
    </div>
    <div class="content">
      <a-table
        :locale="keyword ? searchLocale : locale"
        :columns="columns"
        :data-source="tableList"
        :rowKey="'index'"
        :pagination="pagination"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="tableChange"
      >
        <template #filterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }">
          <div style="padding: 8px">
            <a-cascader
              v-ant-ref="c => (majorInfoRef = c)"
              v-model="selectedMajor"
              allowClear
              :options="majorInfo"
              placeholder="请选择到专业"
              :fieldNames="{ label: 'name', value: 'id', children: 'child' }"
              @change="selectedMajorOk"
            />
          </div>
        </template>
        <template slot="major" slot-scope="text, record">
          {{ `${record.collegeName || $t('shareModal.table.noData')} / ${record.departmentName || $t('shareModal.table.noData')} / ${record.professionName || $t('shareModal.table.noData')}` }}
        </template>
      </a-table>
    </div>
    <div class="pagination">
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handlePaginationChange" />
    </div>
    <div style="margin-bottom: 30px;" v-show="tableList.length"></div>
    <template slot="footer">
      <div style="height: 35px;" v-show="tableList.length">
        <a-button style="width: auto" key="submit" type="primary" @click="handleOk">
          {{ isShare === 2 ? $t('shareModal.button.addShare') : $t('shareModal.button.cancelShare') }}
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import cookie from 'js-cookie'
import { getSchoolMembers, getClasslMembers, share, unShare } from '@/api/lesson'
import Pagination from '@/components/pagination/index.vue'
import Empty from '@/components/Empty'
import { classMap, majorList } from '@/api/experiment'

export default {
  name: 'FailureDetails',
  props: {
    resourceList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Pagination
  },
  data() {
    return {
      visible: false,
      keyword: '',
      data: [],
      tableList: [],
      selectedRows: [],
      resId: null,
      columns: [
        {
          title: this.$t('shareModal.table.sequence'),
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 80
        },
        {
          title: this.$t('shareModal.table.role'),
          dataIndex: 'role',
          key: 'role',
          filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
          filters: [
            {
              text: '学生',
              value: 'student'
            },
            {
              text: '老师',
              value: 'teacher'
            }
          ]
        },
        {
          title: this.$t('shareModal.table.name'),
          dataIndex: 'name',
          key: 'name'
        }
      ],
      isShare: 2,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      locale: {
        emptyText: this.$createElement(Empty, {
          props: {
            margin: 101,
            imgWidth: 200,
            text: this.$t('noDataEmpty'),
            imgSrc: require('@/assets/img/fx_zanwushujv@2x.png')
          }
        })
      },
      searchLocale: {
        emptyText: this.$createElement(Empty, {
          props: {
            margin: 101,
            imgWidth: 200,
            isSearch: true,
            imgSrc: require('@/assets/img/bj_zanwu.png')
          }
        })
      },
      majorInfo: [],
      selectedMajor: [],
      searchParams: {
        userTypes: [],
        classIds: []
      },
      selectedRowKeys: []
    }
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRows = this.tableList.filter(item => {
        if (selectedRowKeys.includes(item.index)) return item
      })
      this.selectedRowKeys = selectedRowKeys
    },
    showModal(id) {
      this.resId = id
      this.visible = true
      this.init()
    },
    handleOk(e) {
      console.log(this.selectedRows)
      const sIds = this.selectedRows.filter(item => item.userType === 'student').map(item => item.userId)
      const tIds = this.selectedRows.filter(item => item.userType === 'teacher').map(item => item.userId)
      const resIds = this.resId ? [this.resId] : this.resourceList.filter(item => item.checked).map(item => item.id)
      const params = {
        ids: resIds,
        teacherIds: tIds,
        studentIds: sIds
      }
      if (this.selectedRows.length === 0) return
      if (this.isShare === 1) {
        unShare(params).then(res => {
          if (res.code != 200) return
          this.visible = false
          this.$emit('cancel')
          this.$message.success(this.$t('shareModal.message.cancelSuccess'))
        })
      } else if (this.isShare === 2) {
        share(params).then(res => {
          if (res.code != 200) return
          this.visible = false
          this.$emit('ok')
          this.$message.success(this.$t('shareModal.message.shareSuccess'))
        })
      }
    },
    getList() {
      const params = {
        ...this.searchParams,
        keyword: this.keyword,
        isShare: this.isShare,
        resourceId: this.resId ? this.resId : ''
      }
      if (this.majorIds) {
        params.professionIds = [this.majorIds]
      }
      const userType = JSON.parse(cookie.get('user_type')).join(',')
      if (userType.includes('student')) {
        getClasslMembers(params).then(res => {
          if (res.code != 200) return
          this.data = res.data.list.map((item, index) => ({
            ...item,
            index: index + 1,
            role: item.userType === 'student' ? '学生' : '老师'
          }))
          this.tableList = this.data.slice(0, 10)
          this.pagination.total = res.data.list.length
        })
      } else {
        getSchoolMembers(params).then(res => {
          if (res.code != 200) return
          this.data = res.data.list.map((item, index) => ({
            ...item,
            index: index + 1,
            role: item.userType === 'student' ? '学生' : '老师'
          }))
          this.tableList = this.data.slice(0, 10)
          this.pagination.total = res.data.list.length
        })
      }
    },
    handlePaginationChange() {
      this.tableList = this.data.slice((this.pagination.page - 1) * 10, (this.pagination.page - 1) * 10 + 10)
      console.log('this.pagination ----->', this.pagination.page)
    },
    search() {
      this.getList()
    },
    getEmptyText() {
      if (this.keyword) {
        return this.$createElement(Empty, {
          props: {
            margin: 80,
            isSearch: true
          }
        })
      }
      return this.$createElement(Empty, {
        props: {
          margin: 80,
          text: '暂无数据',
          imgSrc: require('@/assets/img/fx_zanwushujv@2x.png')
        }
      })
    },
    init() {
      this.selectedRows = []
      this.selectedRowKeys = []
      this.isShare = 2
      this.pagination.page = 1
      const userType = JSON.parse(cookie.get('user_type')).join(',')

      if (!userType.includes('student')) {
        classMap().then(res => {
          this.columns[2].filters = res.data.list.map(item => ({
            text: item.name,
            value: item.id
          }))
        })
      }

      majorList().then(res => {
        this.majorInfo = removeEmptyChild(res.data.list)
        console.log('this.majorInfo ----->', this.majorInfo)
        function removeEmptyChild(data) {
          if (Array.isArray(data)) {
            return data.map(item => removeEmptyChild(item))
          } else if (typeof data === 'object' && data !== null) {
            if (data.child && data.child.length === 0) {
              delete data.child
            } else {
              data.child = removeEmptyChild(data.child)
            }
            return data
          } else {
            return data
          }
        }
      })
      this.getList()
    },
    selectedMajorOk() {
      if (this.selectedMajor.length === 3) {
        this.majorIds = this.selectedMajor[2]
      } else {
        this.majorIds = ''
      }
      this.getList()
    },
    tableChange(p, filters, sort) {
      console.log('filters ----->', filters)
      this.searchParams = {
        userTypes: filters.role,
        classIds: filters.className
      }
      this.getList()
    },
    changeShareStatus() {
      this.selectedRowKeys = []
      this.getList()
    }
  },
  created() {
    const userType = JSON.parse(cookie.get('user_type')).join(',')
    if (!userType.includes('student')) {
      this.columns.splice(1, 0, {
        title: this.$t('shareModal.table.class'),
        dataIndex: 'className',
        key: 'className',
        filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
        filters: []
      })
    }
  }
}
</script>

<style lang="less" scoped>
.share-modal {
  color: red;
  /deep/ .ant-modal-body {
    padding-top: 0;
  }
}
.list-pagination {
  position: absolute;
  // bottom: 50px;
  width: calc(100%);
  /deep/ .pagination {
    padding: 12px 0;
  }
}
.search {
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-select,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix {
      > img {
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear {
      width: 14px;
      height: 14px;
    }
    .ant-input:not(:last-child) {
      padding-right: 89px;
    }
  }
  /deep/.ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    position: relative;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 69px;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      width: 100%;
      height: 35px;
      .ant-input {
        width: 100%;
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-radius: 20px;
        box-shadow: none;
        border: 1px solid #d8dce0;
        &:focus {
          border-color: #ffb829;
          box-shadow: 0 0 0 2px rgba(255, 160, 0, 0.2);
        }
      }
    }
    .ant-input-group-addon {
      position: absolute;
      right: 63px;
      top: 0;
      border-radius: 20px;
      z-index: 2;
      background: none;
      .search-btn {
        border-left: 0;
        height: 35px;
        border-color: rgba(0, 0, 0, 0);
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background: none;
        padding-right: 109px;
        &::after {
          content: none;
        }
        span {
          display: flex;
          font-size: 14px;
          color: #333333;
          position: relative;
          align-items: center;
          &::before {
            left: -8px;
            content: '';
            width: 1px;
            height: 15px;
            background: #e9e9e9;
            position: absolute;
          }
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  /deep/ .ant-radio-button-wrapper-checked {
    background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%) !important;
    &:hover {
      background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%) !important;
    }
  }
  /deep/ .ant-radio-button-wrapper {
    background: #edf3fa;
    border: none;
  }
}
.content {
  // height: calc(80vh - 200px);
  max-height: 460px;
  overflow: auto;
  // box-shadow: 0px -1px 10px #ededed;
  /deep/ .ant-table-wrapper .ant-table-thead > tr > th {
    padding: 8px 16px;
  }
}
.pagination {
  position: relative;
}
</style>
